export default class ReviewTopicModel {
  id?: string;
  name: string;
  parent?: string;
  children?: ReviewTopicModel[];

  constructor(data?: any) {
    this.id = data?.id || undefined;
    this.name = data?.name || undefined;
    this.parent = data?.parent || undefined;
    this.children = data?.children || undefined;
  }
}
